// extracted by mini-css-extract-plugin
module.exports = {"card":"ExpertiseCard_card__kcYol","data":"ExpertiseCard_data__S0GDz","skills":"ExpertiseCard_skills__2fab9"};